export const warehouseLocationIds = {
  id: 10,
  ky: 40,
  kyProduction: 401,
  ut: 50,
  utProduction: 501,
  tampa: 71,
  dallas: 62,
};

export const nonProductionLocationIds = {
  ut: warehouseLocationIds.ut,
  ky: warehouseLocationIds.ky,
  id: warehouseLocationIds.id,
};

export const shippableLocationIds = {
  ut: warehouseLocationIds.ut,
  ky: warehouseLocationIds.ky,
  fl: warehouseLocationIds.tampa,
  tx: warehouseLocationIds.dallas,
};

export const warehouseAlphaCodes = {
  idaho: 'ID',
  kentucky: 'KY',
  utah: 'UT',
  dropShip: 'DS',
  kentuckyProduction: 'KY-P',
  utahProduction: 'UT-P',
  tampa: 'TAMPA',
  dallas: 'TX',
};

export const warehouseFriendlyAbbreviations = {
  [warehouseLocationIds.id]: 'ID',
  [warehouseLocationIds.ky]: 'KY',
  [warehouseLocationIds.ut]: 'UT',
  [warehouseLocationIds.tampa]: 'FL',
  [warehouseLocationIds.dallas]: 'TX',
}

export const truckWarehouseOptions = [
  { value: warehouseLocationIds.ky, label: 'Kentucky' },
  { value: warehouseLocationIds.ut, label: 'Utah' },
];

export const whIdKey = {
  [warehouseLocationIds.id]: warehouseAlphaCodes.idaho,
  [warehouseLocationIds.kyProduction]: warehouseAlphaCodes.kentuckyProduction,
  [warehouseLocationIds.ky]: warehouseAlphaCodes.kentucky,
  [warehouseLocationIds.utProduction]: warehouseAlphaCodes.utahProduction,
  [warehouseLocationIds.ut]: warehouseAlphaCodes.utah,
  [warehouseLocationIds.tampa]: warehouseAlphaCodes.tampa,
};
